import { ModalWindow, Spinner } from '@cian/ui-kit';
import * as React from 'react';
import { ILocationItem } from '../../../../types/buildersLocations';
import { LocationPickerHeader, LocationPickerFavorites, LocationPickerColumns } from './components';
import { ILocationsColumn, ISuggestion } from './types';
import * as styles from './LocationPickerModal.css';

interface ILocationPickerModalProps {
  opened: boolean;
  loading: boolean;
  searchQuery: string;
  locationsFavorites: ILocationItem[];
  locationsColumns: ILocationsColumn[];
  locationsSuggestions: ISuggestion[];
  onClose(): void;
  onLocationSelect(locationId: number): void;
  onLocationSearch(text: string): void;
}

export const LocationPickerModal: React.FC<ILocationPickerModalProps> = ({
  opened,
  loading,
  searchQuery,
  locationsFavorites,
  locationsColumns,
  locationsSuggestions,
  onClose,
  onLocationSelect,
  onLocationSearch,
}) => {
  return (
    <ModalWindow
      width={1000}
      fixed
      open={opened}
      onClose={onClose}
      header={
        <LocationPickerHeader
          query={searchQuery}
          suggestions={locationsSuggestions}
          onSearch={onLocationSearch}
          onSelect={onLocationSelect}
        />
      }
    >
      {loading ? (
        <div className={styles['loader']}>
          <Spinner size={30} />
        </div>
      ) : (
        <div className={styles['content']}>
          {!!locationsFavorites.length && (
            <LocationPickerFavorites locations={locationsFavorites} onLinkClick={onLocationSelect} />
          )}
          <LocationPickerColumns columns={locationsColumns} onLinkClick={onLocationSelect} />
        </div>
      )}
    </ModalWindow>
  );
};
